import IPhoneNumber from "@/app/dto/IPhoneNumber";

export default class PhoneNumber implements IPhoneNumber {
    constructor(public countryCode: string, public number: string) {
    }
}
